<template>
  <el-dialog v-model="isShow" title="小海职帮你选课程" width="98%" top="1vh" draggable class='currentDialog_xz'>
    <div class="ai-search-component ">
      <el-scrollbar ref="bot_history_scrollbar">
        <div class="content">
          <div v-for="(msgObj, index) in current_bot_history" :key='index' :ref="'new_div_' + index" :class="[msgObj.who=='user'?'show_send_content_position_right':'show_send_content_position_left']">
            <el-image
              v-if="msgObj.type== 'img'"
              style="width: 200px;"
              :src="msgObj.content"
              :preview-src-list="[msgObj.content]"
              :zoom-rate="1.2"
              :max-scale="7"
              :min-scale="0.2"
              :initial-index="4"
              fit="cover"
            >
            </el-image>
            <div class="firstContent" v-else>
              <el-tag v-if="msgObj.type=='kechengtuijian'" size="default" effect="plain" typr="info" style="background-color: unset; color: white;">课程</el-tag>
              <el-tag v-else-if="msgObj.type=='knowledge'" size="default" effect="plain" typr="info" style="background-color: unset; color: white;">知识</el-tag>
              <div v-html="msgObj.content"></div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <template #footer>
      <div class="flex gap-2">
        <el-tag size="small" v-for="(ra, index) in recommendAgents" :key="index" :type="ra['type']" @click="handleRAClick(ra)">{{ ra['content'] }}</el-tag>
      </div>
      <div class="dialog-footer">
        <el-input
          v-model="content"
          style="width: 100%"
          size="large"
          :placeholder="'例如：' + placeholder"
          class="input-with-select"
          @keyup.enter="sendBot"
          v-loading="loading"
        >
          <template #prepend>
            <el-select @focus="isFocus=false" v-model="ai_type" placeholder="请选择类型" :class="isFocus?'w50':'w120'">
              <el-option
                v-for="item in selectAiTypeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
          <template #append>
            <el-button icon="Upload" @click="sendBot" :loading="loading"/>
          </template>
        </el-input>
      </div>
    </template>
  </el-dialog>
</template>
<script>
module.exports = {
  props: {
    title: {
      type: String,
      default: () => {
        return 'ai选课程'
      }
    },
    isisShow:{
      type: Number,
      default: () => {
        return 1
      }
    }
  },
  data() {
    return {
      loading:false,
      isShow: false,
      metaKeyFirstPressTime: 0, // 记录第一次按下Meta键的时间
      content:'',
      ai_type:'kechengtuijian',
      placeholder: "我想查找“爱情之旅”的课程",
      current_bot_history: [{
        'type': 'kechengtuijian',
        'content': '学习关于计算机方面的知识',
        'who': 'user',
      },{
        'type': 'text',
        'content': '课程名称：爱情之旅<br/>课程简介：大学生正值青春年华，他们憧憬着爱情。教育部明文规定要将恋爱教育植入心理课、思政课中，但是受观念和师资问题影响，爱情教育一直徘徊在课堂教学、家庭沟通之外。与此同时，网络、书籍、同龄人交流等非正规途径却成为学生解决恋爱苦恼的主渠道，而由此产生的心理困扰在大学心理咨询问题中占比过半。因此，开设一门以科学理论支撑、具有实操指导的恋爱课程，对学生成长具有重要意义。近年来个别高校开设的爱情课受到学生广泛欢迎，也证明了开设恋爱课程的可行性。<br/>推荐：84.67% <br/>作者：高茹 <br/>链接：<a target="_blank" href=http://jxzypt.hcvt.cn/Detail?_id=28e7563e-851c-11ef-bc6c-fefcfe236ffb&title=%E7%88%B1%E6%83%85%E4%B9%8B%E6%97%85>http://jxzypt.hcvt.cn/Detail?_id=28e7563e-851c-11ef-bc6c-fefcfe236ffb&title=%E7%88%B1%E6%83%85%E4%B9%8B%E6%97%85</a>',
        'who': 'robot',
      }],
      // primary success info warning danger
      recommendAgents:[
        {'type': '', 'content': '了解药剂方面的课程'},
        {'type': 'success', 'content': '我想查找“爱情之旅”的课程'},
        {'type': 'info', 'content': '会计课程'},
      ],
      isFocus: false,
      selectAiTypeOption: [{
          value: 'kechengtuijian',
          label: '课程推荐'
        }, {
          value: 'knowledge',
          label: '知识推荐'
        }, {
          value: '',
          label: 'deepseek'
        }
      ],
      isInitMsg: false
    }
  },
  mounted() {
  },
  beforeDestroy() {

  },
  created() {
    //注册一些监听事件
    //window.removeEventListener('keydown', this.windowKeyDown);
    //window.addEventListener('keydown', this.windowKeyDown);
  },
  methods: {
    init() {

    },
    windowKeyDown(event) {
      if (event.key === 'Meta' || event.key === 'OS') { // 检测Control键
        const currentTime = Date.now(); // 获取当前时间

        // 如果两次按下Meta键的时间间隔小于500毫秒，则认为是双击
        if (this.metaKeyFirstPressTime && (currentTime - this.metaKeyFirstPressTime < 500)) {
          // 触发自定义的双击事件处理函数
          this.doubleMetaKeyPressHandler();

          // 重置记录的时间
          this.metaKeyFirstPressTime = 0;
        } else {
          // 记录第一次按下Meta键的时间
          this.metaKeyFirstPressTime = currentTime;
        }
      }
    },
    doubleMetaKeyPressHandler() {
      // 在这里添加双击Meta键时需要执行的代码
      this.isShow = true
    },
    openedDialog() {
      this.$nextTick(() => {
        
      })
    },
    closeDialog() {

    },
    refreshScrollbarDown(){
      var aa = this.$refs['new_div_' + (this.current_bot_history.length - 1)][0]
      var offsetTop = aa.offsetTop
      this.$refs.bot_history_scrollbar.setScrollTop(offsetTop - 40)
    },
    sendBot(){
      if (this.loading){
        return false;
      }
      this.loading = true
      if (this.content.length == 0){
        this.content = this.placeholder
        this.ai_type = 'kechengtuijian'
      }
      
      let param = {'type': this.ai_type, 'content': this.content, 'who':'user'}
      this.current_bot_history.push(param)
      setTimeout(this.refreshScrollbarDown, 800)
      this.$http.post("/sendBot", param).then(res => {
        this.loading = false
        res = res.replace(/\n/g, "<br>");
        this.current_bot_history.push({
          'type': 'text',
          'content': res,
          'who': 'robot',
        })

        setTimeout(this.refreshScrollbarDown, 800)
        this.content = ''
      }).catch(error => {
        console.log(error)
        console.log('失败')
        this.items = []
        this.loading = false
      })
    },
    handleRAClick(obj){
      this.content = obj['content'];
      this.sendBot()
    }
  },
  components: {},
  watch: {
    isisShow(val){
      if(val){
        this.isShow = true
        if (this.isInitMsg == false){
          this.current_bot_history = []
          this.sendBot()
          this.isInitMsg = true
        }
      }
    }
  },
}
</script>
<style>
.w120{
  width:120px
}
.w50{
  width:50px
}

.currentDialog_xz .el-dialog__body{
  padding-bottom: 2px
}

.ai-search-component {
  font-size: 14px;
}

.ai-search-component .content {
  /* height: calc(100vh - 310px); */
  height: calc(100vh - 280px);
}
.ai-search-component .content .el-scrollbar__wrap {
  overflow-x: auto;
}

.input-with-select .el-input {
  --el-input-height: var(--el-component-size-large);
}

.show_send_content_position_left{
  display: flex;
  width: calc(100% - 16px);
  margin-bottom: 10px;
}

.show_send_content_position_left .firstContent{
    background: #ffffff;
    max-width: calc(80%);
    padding: 12px 12px 12px 12px;
    box-sizing: border-box;
    color: #000000;
    border-radius: 12px;
    box-shadow: 0 1px 16px rgba(92, 121, 154, .1);
    letter-spacing: .5px;
    line-height: 22px;
}

.show_send_content_position_right{
    display: flex;
    flex-direction: row-reverse;
    width: calc(100% - 16px);
    margin-bottom: 10px;
}

.show_send_content_position_right .firstContent{
    background: #1777ff;
    max-width: calc(80%);
    padding: 12px 12px 12px 12px;
    box-sizing: border-box;
    color: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 16px rgba(92, 121, 154, .1);
    letter-spacing: .5px;
    line-height: 22px;
}

.firstContent {
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-all;
}

.flex {
    display: flex;
}

.gap-2 {
    grid-gap: 0.5rem;
    gap: 0.5rem;
    margin-bottom: 5px;
}
</style>